import { H1 } from "@motleyhand/design"
import Account from "./Account"

export default function AccountPage() {
  return (
    <div className="flex flex-col items-center justify-center py-8">
      <H1 className="mb-4">My Account</H1>
      <div className="sm:w-2/3 md:w-1/2">
        <Account />
      </div>
    </div>
  )
}
